
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13526",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13526",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1142",
  "client-types": "static-1.511",
  "data-fetching-client": "static-1.10123",
  "foundations-components": "static-1.8762",
  "foundations-components-legacy": "static-1.1787",
  "foundations-theming": "static-1.4971",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8521",
  "hub-http-shared-msw-handlers": "static-1.10919",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11970",
  "I18n": "static-7.1708",
  "jasmine-runner": "static-1.6935",
  "marketplace-discovery-studio-lib": "static-1.920",
  "marketplace-storefront-base": "static-1.13589",
  "quartz": "static-1.7666",
  "react-dlb": "static-1.94",
  "react-rhumb": "static-1.17220",
  "reactive-variable-buffer-atom": "static-1.3335",
  "reporting-testing-lib": "static-1.11310",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.13010",
  "SharedI18nStrings": "static-1.188",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7862",
  "ui-addon-i18n": "static-1.11628",
  "ui-addon-react-router-dom": "static-1.10007",
  "unified-auth": "static-1.1274",
  "unified-auth-core-lib": "static-1.1556",
  "usage-tracker": "static-1.7807",
  "usage-tracker-core": "static-1.7657",
  "customer-data-property-utils": "static-1.8533",
  "hub-http": "static-1.6689",
  "integrations-lib": "static-1.17446",
  "marketplace-ui-common": "static-1.21050",
  "marketplace-ui-install": "static-1.1036",
  "property-management-iframe": "static-1.14472",
  "quartz-config": "static-1.1444",
  "quartz-core": "static-1.6885",
  "quartz-routing": "static-1.1096",
  "quick-fetch": "static-1.4234",
  "react": "static-7.203",
  "rpc-client-utils": "static-1.5152",
  "ts-schema": "static-1.4397",
  "ui-universal-auth": "static-1.9760",
  "UIComponents": "static-3.8916",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3943",
  "quartz-webpack": "static-1.3890",
  "bend-plugin-quartz-routing": "static-1.744",
  "ai-components-ui-library": "static-1.10038",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5370",
  "pulse": "static-1.1131",
  "react-codemirror": "static-1.11124",
  "ui-extensions-preview-lib": "static-1.982",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5031",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2687",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9910",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5659",
  "react-virtualized": "static-2.112",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3103",
  "ui-fonts": "static-1.1232",
  "ui-images": "static-2.1277",
  "bend-plugin-foundations-theming": "static-1.3454",
  "foundations-theming-base": "static-1.3956",
  "stylex": "static-1.46",
  "HeadJS": "static-2.822",
  "hs-test-utils-bend-plugin": "static-1.3632",
  "msw": "static-1.103",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4790",
  "ui-addon-video-player": "static-1.9106",
  "ai-rendering-library": "static-1.11415",
  "chirp-fetch": "static-1.2387",
  "connections-embed-lib": "static-1.1769",
  "copilot-toolkit": "static-1.12165",
  "feedback-loader": "static-1.30074",
  "laboratory-lib": "static-3.7629",
  "marketplace-embed": "static-1.23218",
  "marketplace-ui-details": "static-1.10945",
  "marketplace-ui-reviews": "static-1.21005",
  "marketplace-ui-tracking": "static-1.15220",
  "sanitize-text": "static-1.8641",
  "usage-tracker-multi": "static-1.6221",
  "usage-tracker-session-replay": "static-1.5493",
  "beacon-keepalive-queue": "static-1.183",
  "quartz-head": "static-1.1331",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5070",
  "immer": "static-1.105",
  "immerable": "static-1.4624",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2843",
  "reporting-data": "static-1.69377",
  "cssUtils": "static-1.1105",
  "flux-actions": "static-1.381",
  "react-colorpicker": "static-2.10692",
  "react-dnd-compat": "static-1.5092",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10853",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7797",
  "icons": "static-2.703",
  "marketplace-ui-apps-core": "static-1.19582",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4981",
  "foundations-components-test-utils": "static-1.6245",
  "quartz-i18n": "static-1.1341",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.780",
  "ads-unified-auth-lib": "static-1.2002",
  "ai-mcp-auth-lib": "static-1.26",
  "custom-vendor-connection-lib": "static-1.324",
  "google-sheets-integration-lib": "static-1.1347",
  "microsoft-drive-auth-lib": "static-1.545",
  "slack-ui-library": "static-1.10881",
  "surveymonkey-integration-lib": "static-1.882",
  "fsm": "static-1.4240",
  "customer-data-objects": "static-1.8188",
  "property-translator": "static-1.5862",
  "hs-locale-management": "static-1.403",
  "frontend-preferences-client": "static-1.8403",
  "hs-promise-utils": "static-1.6075",
  "hubspot-apollo-client": "static-1.5365",
  "integrations-error-boundary-lib": "static-1.14861",
  "integrations-tracking-lib": "static-1.6103",
  "native-integrations-shared-strings": "static-1.8246",
  "sanitize": "static-1.4957",
  "superstore": "static-1.5242",
  "ui-shepherd-react": "static-3.10761",
  "ai-settings-ui-library": "static-1.8604",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4978",
  "immutable-less": "static-1.5135",
  "marketplace-ui-client-types": "static-1.18457",
  "nav-meta": "static-1.30821",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18549",
  "ui-product-approvals-common": "static-1.1598",
  "ai-studio-lib": "static-1.12784",
  "hubspot-prosemirror": "static-1.19297",
  "integrations-reconnect-lib": "static-1.742",
  "ui-addon-iframeable": "static-1.9558",
  "ui-addon-integrations-directory-panel": "static-2.8436",
  "ui-product-approvals": "static-1.29703",
  "ui-tool-access": "static-1.10642",
  "inbound-db-properties-service-client": "static-1.4154",
  "property-management-common": "static-1.6760",
  "opentelemetry-fe-types": "static-1.274",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.649",
  "quartz-auth": "static-1.1341",
  "quartz-test": "static-1.1341",
  "quartz-tracking": "static-1.1045",
  "trellis-components": "static-1.3122",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.562",
  "HubStyle": "static-2.12277",
  "bender-build-tools": "static-1.3600",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23929",
  "ContentUtils": "static-1.69493",
  "customer-data-objects-ui-components": "static-1.13518",
  "sassPrefix": "static-1.371",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2031",
  "bend-plugin-pulse": "static-1.634",
  "event-emitter": "static-1.1444",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5913",
  "magpie-types": "static-1.5373",
  "stylex-utils": "static-1.175",
  "trellis-theming": "static-1.1491",
  "avatar-components": "static-1.2968",
  "breeze-engine-core": "static-1.1494",
  "breeze-engine-lib": "static-1.2216",
  "breeze-onboarding-components": "static-1.1080",
  "customer-data-filters-ui": "static-1.41395",
  "customer-data-reference-ui-components": "static-1.13658",
  "data-integrations-breeze": "static-1.336",
  "embedded-academy-lib": "static-1.16028",
  "ExportDialog": "static-6.10856",
  "global-styles-ai-lib": "static-1.508",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.921",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.45",
  "reporting-action-components": "static-1.42423",
  "reporting-snowflake": "static-1.57993",
  "reporting-ui-components": "static-2.66646",
  "reporting-visualizations": "static-1.61451",
  "trial-components-library": "static-1.14389",
  "ui-addon-teams": "static-1.22020",
  "upgrade-components-lib": "static-1.736",
  "navigation-components": "static-1.19184",
  "nest": "static-1.718",
  "simple-logging-lib": "static-1.3534",
  "nudge-client-utils": "static-1.3434",
  "fail-safe": "static-1.432",
  "app-governance-lib": "static-1.2758",
  "developer-experience-shared-components": "static-1.11022",
  "purchase-motions-components": "static-1.6641",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10806",
  "usage-tracker-anonymous": "static-1.6224",
  "usage-tracker-public": "static-1.7618",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3777",
  "persist-promise": "static-1.4188",
  "reference-resolvers": "static-1.8666",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4398",
  "hubspot-apollo-cache": "static-1.824",
  "universal-page-editor-lib": "static-1.3495",
  "final-form": "static-1.83",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3838",
  "merchandise-lib": "static-1.286",
  "onboarding-scopes": "static-1.6935",
  "ui-addon-draggable": "static-3.5231",
  "content-assistance-lib": "static-1.8434",
  "content-media-capture": "static-1.5816",
  "customer-data-ui-utilities": "static-1.10314",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24860",
  "growth-payments-core": "static-1.26521",
  "knowledge-content-types": "static-1.8763",
  "PatternValidationJS": "static-1.3366",
  "payment-link-components": "static-1.24472",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20567",
  "ui-addon-emoji-picker": "static-1.10346",
  "ui-business-units-lib": "static-1.9578",
  "video-components-external": "static-1.12449",
  "video-data-lib": "static-1.36107",
  "navigation-messaging": "static-1.8511",
  "collaboration-sidebar": "static-1.59075",
  "trellis-ext-dnd": "static-1.557",
  "crm-component-utils": "static-1.40212",
  "crm-properties-common-lib": "static-1.6378",
  "customer-data-properties": "static-1.53071",
  "external-options-client-types": "static-1.4442",
  "framework-data-schema-resolvers": "static-1.7375",
  "hs-resources": "static-1.667",
  "property-value-citations": "static-1.3685",
  "reference-resolvers-lite": "static-1.8595",
  "opentelemetry-web": "static-1.23",
  "hubspotter-http-shared-msw-handlers": "static-1.10917",
  "base-ui": "static-1.28",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "cms-field-types": "static-1.5293",
  "content-icons-ui": "static-1.2464",
  "atom": "static-1.5555",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1202",
  "trellis-migration-context": "static-1.63",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1194",
  "breeze-artifacts-sdk": "static-1.996",
  "getting-started-shared-tasks": "static-1.19581",
  "onboarding-journeys-lib": "static-1.1248",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44127",
  "customer-data-filters-ui-msw-helpers": "static-1.23830",
  "events-data-lib": "static-1.728",
  "FormUrlGenerator": "static-2.5195",
  "framework-builder-read-service-client": "static-1.4338",
  "multi-account-reference-resolvers": "static-1.1492",
  "onboarding-tours": "static-1.17410",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14785",
  "segments-client-types": "static-1.12184",
  "academy-common-lib": "static-1.15489",
  "dashboard-lib": "static-1.83326",
  "hubspot-prosemirror-plugins": "static-1.19289",
  "share-with-third-party-component-lib": "static-1.9194",
  "ui-asset-management-lib": "static-1.11583",
  "user-context": "static-1.5536",
  "reporting-plugins": "static-1.11002",
  "reporting-reports": "static-1.69053",
  "hubs-service-types": "static-1.1751",
  "purchase-motions-api": "static-1.6644",
  "salesImages": "static-1.740",
  "signup-constants": "static-1.19957",
  "nudge-custom-function-registry": "static-1.3191",
  "nudge-renderer-utils": "static-1.3510",
  "whisper-core-api": "static-1.7653",
  "bend-plugin-fail-safe": "static-1.383",
  "framework-listing-lib": "static-2.29821",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31774",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4620",
  "signup-ui-url-generator": "static-2.8520",
  "onboarding-tours-client": "static-1.5625",
  "one-click-checkout": "static-1.755",
  "platform-infra-nav-components": "static-1.8005",
  "subscription-experience-data-types": "static-1.15448",
  "crm-record-cards-client": "static-1.75",
  "crm-record-cards-service-types": "static-1.3871",
  "location-customization-utils-lib": "static-1.10439",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.83",
  "ui-coaching-tips": "static-1.29591",
  "content-media-composition-data-lib": "static-1.13620",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4910",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3960",
  "seat-types-lib": "static-1.1068",
  "ui-addon-opt": "static-4.8893",
  "commerce-tours-lib": "static-1.6875",
  "growth-onboarding-reliability": "static-1.5566",
  "sales-checkout-service-client": "static-1.4002",
  "data-token-picker": "static-1.17147",
  "FileManagerLib": "static-1.40500",
  "content-media-compositions": "static-2.17627",
  "media-bridge-lib": "static-1.19654",
  "chatspot-widget-iframe": "static-1.23920",
  "collaboration-sidebar-common": "static-1.3872",
  "marketing-platform-lib": "static-1.7389",
  "dnd-kit": "static-1.21",
  "commerce-subscription-lib": "static-1.38071",
  "crm-actions": "static-1.6858",
  "crm-cards-sdk": "static-1.45046",
  "customer-data-properties-shared-msw-handlers": "static-1.10246",
  "customer-data-tracking": "static-1.7353",
  "calling-global-api": "static-1.66217",
  "calling-internal-common": "static-1.31808",
  "calling-lifecycle-internal": "static-1.67599",
  "calling-lifecycle-messages": "static-1.59891",
  "commerce-products-lib": "static-1.10937",
  "conditional-properties-service-client": "static-1.4116",
  "crm-index-visualization-core": "static-1.4768",
  "crm-links": "static-1.6794",
  "crm-pipelines-api-client-types": "static-1.4446",
  "formula-editor": "static-1.15022",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1114",
  "multi-currency-client-types": "static-1.4010",
  "object-builder-ui-client": "static-1.50067",
  "pipeline-validation-client-types": "static-1.4285",
  "smart-data-capture-core": "static-1.491",
  "smart-property-lib": "static-1.8676",
  "tiered-pricing": "static-1.2296",
  "topics-actions-lib": "static-1.665",
  "trellis-ext-i18n": "static-1.1401",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "fdsr-migration-layer": "static-1.494",
  "framework-data-schema-quick-fetch": "static-1.7280",
  "restore-request-side-panel-lib": "static-1.2041",
  "growth-data-modal": "static-1.6146",
  "growth-onboarding-confetti": "static-1.3541",
  "growth-onboarding-next-action-utils": "static-1.3001",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-tracker": "static-1.8142",
  "crm-index-associations-lib": "static-1.6931",
  "academy-service-client": "static-1.4175",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40359",
  "SafeStorage": "static-1.4879",
  "video-embed": "static-1.36941",
  "wootric-nps": "static-1.7299",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25264",
  "viral-links-lib": "static-1.7564",
  "nested-table": "static-1.715",
  "timezone-utils": "static-2.5712",
  "getting-started-shared-tasks-store": "static-1.18699",
  "campaign-roi-lib": "static-1.10846",
  "campaigns-utils-lib": "static-1.3730",
  "ui-addon-calendars": "static-2.5847",
  "customer-data-views-management": "static-1.26371",
  "framework-data-table": "static-2.12853",
  "nudge-custom-ui-functions": "static-1.1752",
  "switchboard-lib": "static-1.719",
  "access-check-ui-lib": "static-1.1898",
  "app-users-service-client": "static-1.6103",
  "app-users-service-types": "static-1.5511",
  "mini-checkout-client": "static-1.27850",
  "onboarding-utils": "static-1.5856",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29576",
  "checkout-sdk": "static-3.24693",
  "payment-method-components": "static-1.7325",
  "touchless-buying-components": "static-1.6561",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.874",
  "growth-onboarding-feedback-components": "static-1.7063",
  "audio-components": "static-1.6584",
  "FileManagerImages": "static-1.38011",
  "video-components": "static-1.14451",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20510",
  "commerce-shared-components-lib": "static-1.19582",
  "commerce-tools-ui-lib": "static-1.11337",
  "crm_data": "static-4.93224",
  "crm-activity-creator-data": "static-1.47755",
  "crm-fe-perf": "static-1.23382",
  "universal-record-utils-lib": "static-1.2384",
  "calling-error-reporting": "static-1.31815",
  "shared-worker-versioning": "static-1.11524",
  "calling-usage-tracker": "static-1.7022",
  "voice-sms-access-library": "static-1.2477",
  "commerce-permissions": "static-1.1267",
  "products-iframe-lib": "static-1.8933",
  "products-ui-components-shared-msw-handlers": "static-1.11301",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11002",
  "sales-views-client-types": "static-1.4740",
  "bark-lib": "static-1.17014",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.931",
  "data-agent-test-utils": "static-1.475",
  "data-agent-utils": "static-1.944",
  "policy-lib": "static-1.7287",
  "react-tinymce": "static-1.56285",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11065",
  "tinymce-config": "static-2.55411",
  "tinymce-plugins": "static-1.58525",
  "onboarding-data-sync-lib": "static-1.2852",
  "growth-onboarding-next-action-components": "static-1.3029",
  "user-context-client": "static-1.4992",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4997",
  "outpost": "static-1.4610",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22370",
  "sales-email-signature-service-client": "static-1.4330",
  "ts-utils-lib": "static-1.633",
  "copilot-messaging": "static-1.2415",
  "crm-export-dialog": "static-1.6761",
  "crm-index-ui-shimmer": "static-1.2988",
  "crm-view-components": "static-1.1508",
  "react-beautiful-dnd": "static-1.75",
  "customer-data-associations": "static-1.7820",
  "tasks-actions-lib": "static-1.451",
  "InboxConnectUtils": "static-4.15858",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.879",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4470",
  "company-details-components": "static-1.6689",
  "react-performance-metrics-lib": "static-1.1035",
  "pricing-pages-ui-components": "static-1.16588",
  "quote-checkout-service-types": "static-1.3942",
  "social-insights-client-types": "static-1.22946",
  "utility-belt": "static-1.3020",
  "payments-enrollment-embed-lib": "static-1.24222",
  "stripe-embedded-components": "static-1.8258",
  "customer-data-rte": "static-1.33916",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6547",
  "payments-post-enroll-local-storage-lib": "static-1.5587",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39188",
  "crm_universal": "static-1.22739",
  "customer-data-email": "static-1.18654",
  "meetings-rte-lib": "static-1.557",
  "universal-associations-select": "static-1.11578",
  "crm-object-search-query-utilities": "static-1.10473",
  "calling-orchestration-schema": "static-1.37254",
  "react-reducer-toolkit": "static-1.16684",
  "enrichment-settings-lib": "static-1.249",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57381",
  "hub-http-contrib": "static-1.3515",
  "interframe": "static-3.5224",
  "tinymce-data": "static-1.41496",
  "ui-addon-sales-email": "static-1.5684",
  "layout-dnd-components": "static-1.13241",
  "layout-dnd-utils": "static-1.12216",
  "ui-brand-identity-lib": "static-1.16969",
  "meetings-connect-utils-lib": "static-1.8101",
  "company-details-service-types": "static-1.4427",
  "segments-query-core": "static-1.1913",
  "pricing-pages-api": "static-1.16453",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29171",
  "sequences-lib": "static-1.8800",
  "ui-gdpr-components": "static-1.10656",
  "meetings-client-types": "static-1.4071",
  "meetings-core": "static-1.779",
  "NamespacedHubStyle": "static-2.9370",
  "ContentData": "static-1.69568",
  "layout-data-lib": "static-1.10541",
  "sequences-client-types-lib": "static-1.8657",
  "advanced-menus-core": "static-1.15828",
  "advanced-menus-lib": "static-1.12577",
  "ui-memberships-settings-lib": "static-1.35216",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15827",
  "simple-menus-lib": "static-1.17344"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13526",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1142",
  "client-types": "/client-types/static-1.511",
  "data-fetching-client": "/data-fetching-client/static-1.10123",
  "foundations-components": "/foundations-components/static-1.8762",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1787",
  "foundations-theming": "/foundations-theming/static-1.4971",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8521",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10919",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11970",
  "I18n": "/I18n/static-7.1708",
  "jasmine-runner": "/jasmine-runner/static-1.6935",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.920",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13589",
  "quartz": "/quartz/static-1.7666",
  "react-dlb": "/react-dlb/static-1.94",
  "react-rhumb": "/react-rhumb/static-1.17220",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3335",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11310",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.13010",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7862",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11628",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10007",
  "unified-auth": "/unified-auth/static-1.1274",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1556",
  "usage-tracker": "/usage-tracker/static-1.7807",
  "usage-tracker-core": "/usage-tracker-core/static-1.7657",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8533",
  "hub-http": "/hub-http/static-1.6689",
  "integrations-lib": "/integrations-lib/static-1.17446",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1036",
  "property-management-iframe": "/property-management-iframe/static-1.14472",
  "quartz-config": "/quartz-config/static-1.1444",
  "quartz-core": "/quartz-core/static-1.6885",
  "quartz-routing": "/quartz-routing/static-1.1096",
  "quick-fetch": "/quick-fetch/static-1.4234",
  "react": "/react/static-7.203",
  "rpc-client-utils": "/rpc-client-utils/static-1.5152",
  "ts-schema": "/ts-schema/static-1.4397",
  "ui-universal-auth": "/ui-universal-auth/static-1.9760",
  "UIComponents": "/UIComponents/static-3.8916",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3943",
  "quartz-webpack": "/quartz-webpack/static-1.3890",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.744",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10038",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5370",
  "pulse": "/pulse/static-1.1131",
  "react-codemirror": "/react-codemirror/static-1.11124",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.982",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5031",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2687",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9910",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5659",
  "react-virtualized": "/react-virtualized/static-2.112",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3103",
  "ui-fonts": "/ui-fonts/static-1.1232",
  "ui-images": "/ui-images/static-2.1277",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3454",
  "foundations-theming-base": "/foundations-theming-base/static-1.3956",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.822",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3632",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4790",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9106",
  "ai-rendering-library": "/ai-rendering-library/static-1.11415",
  "chirp-fetch": "/chirp-fetch/static-1.2387",
  "connections-embed-lib": "/connections-embed-lib/static-1.1769",
  "copilot-toolkit": "/copilot-toolkit/static-1.12165",
  "feedback-loader": "/feedback-loader/static-1.30074",
  "laboratory-lib": "/laboratory-lib/static-3.7629",
  "marketplace-embed": "/marketplace-embed/static-1.23218",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10945",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21005",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15220",
  "sanitize-text": "/sanitize-text/static-1.8641",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6221",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5493",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.183",
  "quartz-head": "/quartz-head/static-1.1331",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5070",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4624",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2843",
  "reporting-data": "/reporting-data/static-1.69377",
  "cssUtils": "/cssUtils/static-1.1105",
  "flux-actions": "/flux-actions/static-1.381",
  "react-colorpicker": "/react-colorpicker/static-2.10692",
  "react-dnd-compat": "/react-dnd-compat/static-1.5092",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10853",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7797",
  "icons": "/icons/static-2.703",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4981",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6245",
  "quartz-i18n": "/quartz-i18n/static-1.1341",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.780",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2002",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.26",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.324",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1347",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.545",
  "slack-ui-library": "/slack-ui-library/static-1.10881",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.882",
  "fsm": "/fsm/static-1.4240",
  "customer-data-objects": "/customer-data-objects/static-1.8188",
  "property-translator": "/property-translator/static-1.5862",
  "hs-locale-management": "/hs-locale-management/static-1.403",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8403",
  "hs-promise-utils": "/hs-promise-utils/static-1.6075",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5365",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14861",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6103",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8246",
  "sanitize": "/sanitize/static-1.4957",
  "superstore": "/superstore/static-1.5242",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10761",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8604",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4978",
  "immutable-less": "/immutable-less/static-1.5135",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "nav-meta": "/nav-meta/static-1.30821",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18549",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1598",
  "ai-studio-lib": "/ai-studio-lib/static-1.12784",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19297",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.742",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9558",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8436",
  "ui-product-approvals": "/ui-product-approvals/static-1.29703",
  "ui-tool-access": "/ui-tool-access/static-1.10642",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4154",
  "property-management-common": "/property-management-common/static-1.6760",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.274",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.649",
  "quartz-auth": "/quartz-auth/static-1.1341",
  "quartz-test": "/quartz-test/static-1.1341",
  "quartz-tracking": "/quartz-tracking/static-1.1045",
  "trellis-components": "/trellis-components/static-1.3122",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.562",
  "HubStyle": "/HubStyle/static-2.12277",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23929",
  "ContentUtils": "/ContentUtils/static-1.69493",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13518",
  "sassPrefix": "/sassPrefix/static-1.371",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2031",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.634",
  "event-emitter": "/event-emitter/static-1.1444",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5913",
  "magpie-types": "/magpie-types/static-1.5373",
  "stylex-utils": "/stylex-utils/static-1.175",
  "trellis-theming": "/trellis-theming/static-1.1491",
  "avatar-components": "/avatar-components/static-1.2968",
  "breeze-engine-core": "/breeze-engine-core/static-1.1494",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2216",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1080",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41395",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13658",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.336",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16028",
  "ExportDialog": "/ExportDialog/static-6.10856",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.508",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.921",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.45",
  "reporting-action-components": "/reporting-action-components/static-1.42423",
  "reporting-snowflake": "/reporting-snowflake/static-1.57993",
  "reporting-ui-components": "/reporting-ui-components/static-2.66646",
  "reporting-visualizations": "/reporting-visualizations/static-1.61451",
  "trial-components-library": "/trial-components-library/static-1.14389",
  "ui-addon-teams": "/ui-addon-teams/static-1.22020",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.736",
  "navigation-components": "/navigation-components/static-1.19184",
  "nest": "/nest/static-1.718",
  "simple-logging-lib": "/simple-logging-lib/static-1.3534",
  "nudge-client-utils": "/nudge-client-utils/static-1.3434",
  "fail-safe": "/fail-safe/static-1.432",
  "app-governance-lib": "/app-governance-lib/static-1.2758",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11022",
  "purchase-motions-components": "/purchase-motions-components/static-1.6641",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10806",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6224",
  "usage-tracker-public": "/usage-tracker-public/static-1.7618",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3777",
  "persist-promise": "/persist-promise/static-1.4188",
  "reference-resolvers": "/reference-resolvers/static-1.8666",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4398",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.824",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3495",
  "final-form": "/final-form/static-1.83",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3838",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "onboarding-scopes": "/onboarding-scopes/static-1.6935",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5231",
  "content-assistance-lib": "/content-assistance-lib/static-1.8434",
  "content-media-capture": "/content-media-capture/static-1.5816",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10314",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24860",
  "growth-payments-core": "/growth-payments-core/static-1.26521",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "PatternValidationJS": "/PatternValidationJS/static-1.3366",
  "payment-link-components": "/payment-link-components/static-1.24472",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20567",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10346",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9578",
  "video-components-external": "/video-components-external/static-1.12449",
  "video-data-lib": "/video-data-lib/static-1.36107",
  "navigation-messaging": "/navigation-messaging/static-1.8511",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59075",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.557",
  "crm-component-utils": "/crm-component-utils/static-1.40212",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6378",
  "customer-data-properties": "/customer-data-properties/static-1.53071",
  "external-options-client-types": "/external-options-client-types/static-1.4442",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7375",
  "hs-resources": "/hs-resources/static-1.667",
  "property-value-citations": "/property-value-citations/static-1.3685",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8595",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10917",
  "base-ui": "/base-ui/static-1.28",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "cms-field-types": "/cms-field-types/static-1.5293",
  "content-icons-ui": "/content-icons-ui/static-1.2464",
  "atom": "/atom/static-1.5555",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1202",
  "trellis-migration-context": "/trellis-migration-context/static-1.63",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1194",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.996",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19581",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1248",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44127",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23830",
  "events-data-lib": "/events-data-lib/static-1.728",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5195",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4338",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1492",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14785",
  "segments-client-types": "/segments-client-types/static-1.12184",
  "academy-common-lib": "/academy-common-lib/static-1.15489",
  "dashboard-lib": "/dashboard-lib/static-1.83326",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19289",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9194",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11583",
  "user-context": "/user-context/static-1.5536",
  "reporting-plugins": "/reporting-plugins/static-1.11002",
  "reporting-reports": "/reporting-reports/static-1.69053",
  "hubs-service-types": "/hubs-service-types/static-1.1751",
  "purchase-motions-api": "/purchase-motions-api/static-1.6644",
  "salesImages": "/salesImages/static-1.740",
  "signup-constants": "/signup-constants/static-1.19957",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3191",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3510",
  "whisper-core-api": "/whisper-core-api/static-1.7653",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.383",
  "framework-listing-lib": "/framework-listing-lib/static-2.29821",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31774",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4620",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "one-click-checkout": "/one-click-checkout/static-1.755",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8005",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15448",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.75",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10439",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.83",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29591",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13620",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4910",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3960",
  "seat-types-lib": "/seat-types-lib/static-1.1068",
  "ui-addon-opt": "/ui-addon-opt/static-4.8893",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6875",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5566",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4002",
  "data-token-picker": "/data-token-picker/static-1.17147",
  "FileManagerLib": "/FileManagerLib/static-1.40500",
  "content-media-compositions": "/content-media-compositions/static-2.17627",
  "media-bridge-lib": "/media-bridge-lib/static-1.19654",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23920",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3872",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7389",
  "dnd-kit": "/dnd-kit/static-1.21",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38071",
  "crm-actions": "/crm-actions/static-1.6858",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45046",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10246",
  "customer-data-tracking": "/customer-data-tracking/static-1.7353",
  "calling-global-api": "/calling-global-api/static-1.66217",
  "calling-internal-common": "/calling-internal-common/static-1.31808",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67599",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59891",
  "commerce-products-lib": "/commerce-products-lib/static-1.10937",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4116",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4768",
  "crm-links": "/crm-links/static-1.6794",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4446",
  "formula-editor": "/formula-editor/static-1.15022",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1114",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4010",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50067",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4285",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.491",
  "smart-property-lib": "/smart-property-lib/static-1.8676",
  "tiered-pricing": "/tiered-pricing/static-1.2296",
  "topics-actions-lib": "/topics-actions-lib/static-1.665",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1401",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.494",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7280",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2041",
  "growth-data-modal": "/growth-data-modal/static-1.6146",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3541",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3001",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8142",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6931",
  "academy-service-client": "/academy-service-client/static-1.4175",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40359",
  "SafeStorage": "/SafeStorage/static-1.4879",
  "video-embed": "/video-embed/static-1.36941",
  "wootric-nps": "/wootric-nps/static-1.7299",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25264",
  "viral-links-lib": "/viral-links-lib/static-1.7564",
  "nested-table": "/nested-table/static-1.715",
  "timezone-utils": "/timezone-utils/static-2.5712",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18699",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10846",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3730",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5847",
  "customer-data-views-management": "/customer-data-views-management/static-1.26371",
  "framework-data-table": "/framework-data-table/static-2.12853",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1752",
  "switchboard-lib": "/switchboard-lib/static-1.719",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1898",
  "app-users-service-client": "/app-users-service-client/static-1.6103",
  "app-users-service-types": "/app-users-service-types/static-1.5511",
  "mini-checkout-client": "/mini-checkout-client/static-1.27850",
  "onboarding-utils": "/onboarding-utils/static-1.5856",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29576",
  "checkout-sdk": "/checkout-sdk/static-3.24693",
  "payment-method-components": "/payment-method-components/static-1.7325",
  "touchless-buying-components": "/touchless-buying-components/static-1.6561",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.874",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7063",
  "audio-components": "/audio-components/static-1.6584",
  "FileManagerImages": "/FileManagerImages/static-1.38011",
  "video-components": "/video-components/static-1.14451",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20510",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19582",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11337",
  "crm_data": "/crm_data/static-4.93224",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47755",
  "crm-fe-perf": "/crm-fe-perf/static-1.23382",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2384",
  "calling-error-reporting": "/calling-error-reporting/static-1.31815",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11524",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7022",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2477",
  "commerce-permissions": "/commerce-permissions/static-1.1267",
  "products-iframe-lib": "/products-iframe-lib/static-1.8933",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11301",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11002",
  "sales-views-client-types": "/sales-views-client-types/static-1.4740",
  "bark-lib": "/bark-lib/static-1.17014",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.931",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.475",
  "data-agent-utils": "/data-agent-utils/static-1.944",
  "policy-lib": "/policy-lib/static-1.7287",
  "react-tinymce": "/react-tinymce/static-1.56285",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11065",
  "tinymce-config": "/tinymce-config/static-2.55411",
  "tinymce-plugins": "/tinymce-plugins/static-1.58525",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2852",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3029",
  "user-context-client": "/user-context-client/static-1.4992",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4997",
  "outpost": "/outpost/static-1.4610",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22370",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4330",
  "ts-utils-lib": "/ts-utils-lib/static-1.633",
  "copilot-messaging": "/copilot-messaging/static-1.2415",
  "crm-export-dialog": "/crm-export-dialog/static-1.6761",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2988",
  "crm-view-components": "/crm-view-components/static-1.1508",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.75",
  "customer-data-associations": "/customer-data-associations/static-1.7820",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.451",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15858",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.879",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4470",
  "company-details-components": "/company-details-components/static-1.6689",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1035",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16588",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3942",
  "social-insights-client-types": "/social-insights-client-types/static-1.22946",
  "utility-belt": "/utility-belt/static-1.3020",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24222",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8258",
  "customer-data-rte": "/customer-data-rte/static-1.33916",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6547",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5587",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39188",
  "crm_universal": "/crm_universal/static-1.22739",
  "customer-data-email": "/customer-data-email/static-1.18654",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.557",
  "universal-associations-select": "/universal-associations-select/static-1.11578",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10473",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37254",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16684",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.249",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57381",
  "hub-http-contrib": "/hub-http-contrib/static-1.3515",
  "interframe": "/interframe/static-3.5224",
  "tinymce-data": "/tinymce-data/static-1.41496",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5684",
  "layout-dnd-components": "/layout-dnd-components/static-1.13241",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12216",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16969",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8101",
  "company-details-service-types": "/company-details-service-types/static-1.4427",
  "segments-query-core": "/segments-query-core/static-1.1913",
  "pricing-pages-api": "/pricing-pages-api/static-1.16453",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29171",
  "sequences-lib": "/sequences-lib/static-1.8800",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "meetings-client-types": "/meetings-client-types/static-1.4071",
  "meetings-core": "/meetings-core/static-1.779",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9370",
  "ContentData": "/ContentData/static-1.69568",
  "layout-data-lib": "/layout-data-lib/static-1.10541",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8657",
  "advanced-menus-core": "/advanced-menus-core/static-1.15828",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12577",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35216",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15827",
  "simple-menus-lib": "/simple-menus-lib/static-1.17344"
}
};
